// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import ScrapInputBlock from './ScrapInputBlock/ScrapInputBlock';
import { getLocalizedCountry } from '../../local-values/utils/countries';
import CarouselProducts from '../../../elements/CarouselProducts/CarouselProducts';
import { urlVerifier } from '../../../utils/string';
import { CommaFormat } from '../../../elements/Price/Price';

import style from './ProductList.scss';
import buttonStyle from '../../../assets/styles/button.scss';

import type { ProductList as ProductListType, ProductListItem } from '../../../entities';
import type { Match } from '../../../router';
import type { LocaleState } from '../../locale/duck';
import type { LocalValuesState } from '../../local-values/duck';

type Props = {
  +productList?: ProductListType;
  +isFetchingProductList?: boolean;
  +fetchProductList: (name: string) => void;
  +match: Match;
  +locale: LocaleState;
  +localValues: LocalValuesState;
  +goToRedirect: (route: string) => void;
  +resetState: () => void;
};

export default class ProductList extends Component<Props> {
  componentDidMount() {
    const { productList, fetchProductList, match } = this.props;
    if (!productList) {
      fetchProductList(match.params.name || '');
    }
  }

  componentWillUnmount() {
    const { resetState } = this.props;
    resetState();
  }

  render() {
    const { productList, locale, localValues, goToRedirect } = this.props;
    const isSingleProduct = productList && productList.products.length === 1;
    const upperLocale = locale.locale ? locale.locale.toUpperCase() : 'ES';

    return (
      <Fragment>
        <section className={style.topBanner}
          /*style={productList && { background: `#${productList.color}` }}*/>
          <article className={style.content}>
            {productList && <img src={productList.image} alt={productList.slug}/>}
            {productList && !!productList.title[upperLocale] && !!productList.subtitle[upperLocale] &&
            <section className={style.textWrap}>
              <h1>{productList.title[upperLocale]}</h1>
              {/* TODO: Change this. The translations must be regionalized */}
              {productList.subtitle[upperLocale] && <FormattedMessage id="productList.top.from">{
                txt => <h2>{productList.subtitle[upperLocale]} {locale.domainCountry !== 'US' && txt}
                  {locale.domainCountry !== 'US' &&
                  ` ${getLocalizedCountry(locale.domainCountry || 'PE', this.context.intl.formatMessage, localValues.countriesMap)}.`}</h2>
              }</FormattedMessage>}
              {isSingleProduct && <FormattedMessage id="productList.top.button">{
                txt => <Link to={!productList.products[0].b64 ?
                  `/new-order/product?initialQuery=${productList.products[0].url}` :
                  `/new-order/product?product=${productList.products[0].b64}`}
                             className={classNames(buttonStyle.btn, buttonStyle.lightBlueInverse, style.buy)}>{txt}
                </Link>
              }</FormattedMessage>}
            </section>}
          </article>
        </section>
        {/*{productList && productList.products.length > 1 &&
        <CarouselItems title="productList.carousel.popular.title"
                          products={productList.products}
                          locale={locale}
                          goToRedirect={goToRedirect}/>}
        {productList && productList.relatedProducts.length > 0 &&
        <CarouselItems title="productList.carousel.related.title"
                          products={productList.relatedProducts}
                          locale={locale}
                          goToRedirect={goToRedirect}/>}*/}
        {!!productList && <section className={style.infoWrap}>
          <h2>{productList.label1[upperLocale]}</h2>
          <p>{productList.paragraph1[upperLocale]}</p>
        </section>}
        <section className={style.hrWrap}>
          <hr className={style.hr}/>
        </section>
        <section className={style.productsWrap}>
          <FormattedMessage id="productList.popular.title">{
            txt => <h2>{txt}</h2>
          }</FormattedMessage>
          {productList && productList.products.length > 0 &&
          productList.products.map((p: ProductListItem, index: number) => (
            <section className={style.product} key={index}>
              <section className={style.main}>
                <img src={p.image} alt="Qempo"/>
                <section className={style.content}>
                  <section className={style.detail}>
                    <p className={style.name}>{p.name}</p>
                    <FormattedMessage id="productList.popular.price">{
                      text => <p className={style.price}>{text}: $ <CommaFormat price={p.price}/></p>
                    }</FormattedMessage>
                    {/*<img className={style.store} src={amazon} alt="Amazon"/>*/}
                  </section>
                  <FormattedMessage id="productList.popular.quote">{
                    text => <Link
                      to={!!p.b64 ? `/new-order/product?product=${p.b64}` : `/new-order/product?initialQuery=${p.url}`}
                      className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}>{text}</Link>
                  }</FormattedMessage>
                </section>
              </section>
              {p.detail && <section className={style.description}>
                <FormattedMessage id="productList.popular.description">{
                  text => <label>{text}</label>
                }</FormattedMessage>
                <p>{p.detail}</p>
              </section>}
            </section>
          ))}
          {/*{productList && productList.products.length > 0 &&
          <CarouselOrders title="productList.carousel.popular.title"
                          items={productList.products}/>}*/}
        </section>
        <section className={style.hrWrap}>
          <hr className={style.hr}/>
        </section>
        {!!productList && !!productList.label2[upperLocale] && !!productList.paragraph2[upperLocale] &&
        <section className={style.infoWrap}>
          <h2>{productList.label2[upperLocale]}</h2>
          <p>{productList.paragraph2[upperLocale]}</p>
        </section>}
        <section className={style.hrWrap}>
          <hr className={style.hr}/>
        </section>
        <section className={style.carouselWrap}>
          {productList && productList.relatedProducts.length > 0 &&
          <CarouselProducts title="productList.carousel.related.title"
                            items={productList.relatedProducts}
                            hasFixedItems={false}/>}
        </section>
        <ScrapInputBlock handleClickButton={(input: string) =>
          goToRedirect(`/new-order/product?initialQuery=${input}`)}/>
      </Fragment>
    );
  }
}

ProductList.propTypes = {
  productList: PropTypes.object,
  isFetchingProductList: PropTypes.bool,
  fetchProductList: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  locale: PropTypes.object.isRequired,
  localValues: PropTypes.object.isRequired,
  goToRedirect: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired,
};

ProductList.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/product-list/components/ProductList.jsx